"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformFieldsService = void 0;
var inversify_1 = require("inversify");
var fields_1 = require("../constants/fields");
var TransformFieldsService = /** @class */ (function () {
    function TransformFieldsService() {
    }
    TransformFieldsService.prototype.transformKey = function (data, excludeKeys, transformer) {
        var _this = this;
        var result = {};
        if (!data) {
            return data;
        }
        var keys = Object.keys(data);
        keys.forEach(function (k) {
            var key = transformer(k);
            var value = data[k];
            if (excludeKeys.includes(k)) {
                result[k] = data[k];
            }
            else if (Array.isArray(value) && !fields_1.NO_DEEP_TRANSFORM_KEYS.includes(k)) {
                result[key] = value.map(function (v) {
                    if (typeof v === "object" && !fields_1.NO_DEEP_TRANSFORM_KEYS.includes(k)) {
                        return _this.transformKey(v, excludeKeys, transformer);
                    }
                    return v;
                });
            }
            else if (value && typeof value === "object" && !fields_1.NO_DEEP_TRANSFORM_KEYS.includes(k)) {
                result[key] = _this.transformKey(value, excludeKeys, transformer);
            }
            else {
                result[key] = value;
            }
        });
        return result;
    };
    TransformFieldsService.prototype.toAbbr = function (records, excludeKeys) {
        var _this = this;
        if (excludeKeys === void 0) { excludeKeys = fields_1.EXCLUDE_TRANSFORM_KEYS; }
        var transformed = records.map(function (record) {
            var newRecord = _this.transformKey(record, excludeKeys, function (k) {
                var abbr = k;
                // 获取这个 key 对应的全称，可能不存在
                var fullName = fields_1.FIELDS_FULL_NAME[k];
                // 获取这个 key 对应的简写，可能不存在
                var knownAbbr = (0, fields_1.getKeyByValue)(fields_1.FIELDS_FULL_NAME, k);
                if (k === "extraInfo" || k === "elementExtraInfo") {
                    abbr = "ext";
                }
                else if (fullName) {
                    // 有全称，则直接使用 k 简写
                    abbr = k;
                }
                else if (knownAbbr) {
                    // 如果是已知的全称，则获取对应的 key，为简写
                    abbr = knownAbbr;
                }
                return abbr;
            });
            return newRecord;
        });
        return transformed;
    };
    TransformFieldsService.prototype.toFullName = function (records, excludeKeys) {
        var _this = this;
        if (excludeKeys === void 0) { excludeKeys = []; }
        var transformed = records.map(function (record) {
            var newRecord = _this.transformKey(record, excludeKeys, function (k) {
                return fields_1.FIELDS_FULL_NAME[k] || k;
            });
            return newRecord;
        });
        return transformed;
    };
    TransformFieldsService = __decorate([
        (0, inversify_1.injectable)()
    ], TransformFieldsService);
    return TransformFieldsService;
}());
exports.TransformFieldsService = TransformFieldsService;
